import { useEffect, useRef, useState } from "react";
import { Button, Col, FormCheck, FormGroup, FormLabel, Row, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router";
import { useProfile } from "../components/ProfileContext";
import { SimpleFormField } from "../components/SimpleFormField";
import { Inspection } from "../models/Inspection";
import { InspectionComponent } from "../models/InspectionComponent";
import { Api } from "../util/Api";
import { LoadingComponent } from "../components/LoadingComponent";
import { InspectionsTable } from "../forms/InspectionsTable";
import { archiveComponent, getRandomId, setNavAdvisoryLockout } from "../util/utils";
import { Survey } from "../models/Survey";

export function AssetPage(props) {
	setNavAdvisoryLockout(false);

	let params = useParams();
	let requestedAssetNumber = params.assetNumber;

	let [profile] = useProfile();
	let [searchResults, setSearchResults] = useState(null);
	let [searchState, setSearchState] = useState(null);
	let [assetNumber, setAssetNumber] = useState(requestedAssetNumber);
	let checkRef = useRef();
	let inputRef = useRef();
	let navigate = useNavigate();
	let assetNumberEntered = async function() {
		setSearchState("searching");
		setAssetNumber(inputRef.current.value);

		let includeArchived = checkRef.current.checked;
		try {
			let results = await Api.forProfile(profile).componentLookup(inputRef.current.value, includeArchived);
			setSearchResults(results);
			setSearchState("done");
		} catch(err) {
			// We just get a 404 when the component isn't found
			setSearchResults({"inspections":[]});
			setSearchState("done");
		}
	};

	let inspectionsFound = (searchResults?.["inspections"]?.length || 0) != 0

	useEffect(() => {
		if(!!requestedAssetNumber) {
			assetNumberEntered();
		}
	}, [requestedAssetNumber])

	let buildInspectionFromPrevious = async (prevInsp) => {
		let insp = Inspection.generateInspectionFromProfile(profile);
		await insp.populateMetadataFromPreviousInspectionData(prevInsp);
		return insp;
	}

	let startInspectionAction = async () => {
		let insp = await buildInspectionFromPrevious(searchResults?.["inspections"]?.[0]);
		navigate("/inspections/new", {state:{inspection:insp, assetNumber: assetNumber, startTab:(!!insp.surveyId ? "survey" : "setup")}});
	};

	let archiveAction = async () => {
		if(confirm("Are you sure you want to archive this asset and its inspections?")) {
			await archiveComponent(profile, assetNumber);
			assetNumberEntered();
		}
	};

	return <div className="assetpageContainer">
		<h1>
			Asset Lookup
		</h1>
		<div className="clearfix"></div>
		<Row>
			<Col xs="9">
				<SimpleFormField inputRef={inputRef} label="Asset Number" scannable={true} afterScan={assetNumberEntered} defaultValue={requestedAssetNumber} />
			</Col>
			<Col xs="3" style={{textAlign:"right"}}>
				<FormGroup>
					<FormLabel>&nbsp;</FormLabel><br /> {/* match spacing of field */}
					<Button onClick={assetNumberEntered}>Search</Button>
				</FormGroup>
			</Col>
		</Row>
		<Row className="mt-2">
			<Col xs="12">
				Include Archived? &nbsp;&nbsp; <input type="checkbox" ref={checkRef} />
			</Col>
		</Row>

		{searchState == "searching" && <LoadingComponent />}
		{searchState == "done" && <div className="mt-4">
			<hr />
			{profile.isAllowedToStartInspection && <Button onClick={startInspectionAction}>Start Inspection</Button>}
			{inspectionsFound && <Button className="float-end" variant="danger" onClick={archiveAction}>Archive</Button>}
			{searchResults != null && <div>
				<h2 className="mt-4">Previous Inspections</h2>
				{!inspectionsFound && <p>No inspections found.</p>}
				{inspectionsFound && <div>
					<InspectionsTable inspections={searchResults["inspections"]} />
				</div>}
			</div>}
		</div>}
	</div>;
}